export const enum State {
    NOT_INITIALIZED,
    COMPUTING,
    CLEAN,
    PASSIVE,
    DIRTY,
    DESTROYED,
}

export const MAX_REACTION_ITERATIONS = 1000;
